import { useState } from 'react';
import { Space, Typography } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import { PlusOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { StyledSelect } from 'components/new-ui/composed/formSelect/styles';
import ChargeOptionsHeader from './ChargeOptionsHeader';

export type ChargeSelectOption = DefaultOptionType & { id?: string; rawData?: any };

type Props = {
    open: boolean;
    charges: ChargeSelectOption[];
    isLoading?: boolean;
    onSearch?: (value: string) => void;
    onClear?: () => void;
    onCancel?: () => void;
    onConfirm: (charge: ChargeSelectOption) => void;
};

const SelectChargeModal = ({ open, charges, isLoading, onSearch, onCancel, onClear, onConfirm }: Props) => {
    const [selectedCharge, setSelectedCharge] = useState<ChargeSelectOption>();

    return (
        <ConfirmationModal
            destroyOnClose
            open={open}
            icon={<PlusOutlined />}
            title="Add Additional Charge"
            confirmButtonText="Add"
            onCancel={onCancel}
            onConfirm={() => {
                if (!selectedCharge) return;
                onConfirm(selectedCharge);
                onClear?.();
                onCancel?.();
            }}
            content={
                <Space direction="vertical" size={16} style={{ textAlign: 'left', width: '100%' }}>
                    <Typography.Text style={{ textAlign: 'left' }}>
                        Select Additional Charge. You can search by code or description.
                    </Typography.Text>
                    <StyledSelect
                        style={{ width: '100%' }}
                        options={charges}
                        showSearch
                        allowClear
                        loading={isLoading}
                        placeholder="Search by code or description"
                        filterOption={false}
                        onSearch={onSearch}
                        onClear={onClear}
                        onSelect={(_, option) => {
                            setSelectedCharge(option as ChargeSelectOption);
                        }}
                        dropdownRender={(menu) => (
                            <>
                                <ChargeOptionsHeader />
                                {menu}
                            </>
                        )}
                    />
                </Space>
            }
        />
    );
};

export default SelectChargeModal;
